 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"2b65b2463ab966e0a2472ed65ab7efa82e74a3bd","1":"bac1b955","4":"component---src-accessibility-statement-mdx","5":"component---src-apple-developer-account-links-mdx","6":"component---src-change-language-mdx","7":"component---src-click-collect-mdx","8":"component---src-configure-a-gps-location-mdx","9":"component---src-configure-account-push-notifications-mdx","10":"component---src-configure-ad-hoc-push-notifications-mdx","11":"component---src-configure-app-authentication-mdx","12":"component---src-configure-barcode-self-check-mdx","13":"component---src-configure-click-collect-mdx","14":"component---src-configure-dynamic-tabs-mdx","15":"component---src-configure-minimum-app-version-mdx","16":"component---src-configure-patron-account-options-mdx","17":"component---src-configure-rfid-self-check-mdx","18":"component---src-configure-stripe-payments-mdx","19":"component---src-configure-ui-colors-mdx","20":"component---src-create-a-content-item-mdx","21":"component---src-create-a-self-service-tab-mdx","22":"component---src-create-a-tab-mdx","23":"component---src-create-a-user-mdx","24":"component---src-create-dynamic-home-tabs-mdx","25":"component---src-delete-a-channel-mdx","26":"component---src-delete-a-content-item-mdx","27":"component---src-delete-a-content-items-schedule-mdx","28":"component---src-delete-a-tab-mdx","29":"component---src-delete-a-user-mdx","30":"component---src-edit-a-channel-mdx","31":"component---src-edit-a-mobile-app-mdx","32":"component---src-edit-a-tab-mdx","33":"component---src-edit-languages-mdx","34":"component---src-edit-the-home-screen-tab-mdx","35":"component---src-faq-mdx","36":"component---src-generate-an-activity-report-mdx","37":"component---src-getting-started-mdx","38":"component---src-i-phone-user-guide-links-mdx","39":"component---src-link-content-to-a-tab-mdx","40":"component---src-linked-accounts-mdx","41":"component---src-my-lists-mdx","42":"component---src-notifications-mdx","43":"component---src-open-the-staff-dashboard-mdx","44":"component---src-organize-tabs-mdx","45":"component---src-pages-404-js","46":"component---src-pin-a-tab-mdx","47":"component---src-reading-tracker-awards-mdx","48":"component---src-reading-tracker-delete-reviews-mdx","49":"component---src-reading-tracker-mdx","50":"component---src-reading-tracker-reviews-mdx","51":"component---src-releases-mdx","52":"component---src-schedule-a-content-item-mdx","53":"component---src-supported-devices-operating-systems-mdx","54":"component---src-supported-vendors-mdx"}[chunkId]||chunkId) + "-" + {"0":"93e857c51462f4f622a1","1":"0612ca16fb758ff9b3ea","4":"95d1dc594014dfd6cea8","5":"471fba06ef409a46ee0b","6":"3c02b1e5eaa383a9c940","7":"8a3e0c55b368f7a9d267","8":"e9d91b08bbbe985e4987","9":"549d4db2e6070a0c9ecc","10":"a4c3c087612d25e0ee3a","11":"4771e6551182a179b883","12":"579b08d150e1f4211e81","13":"c34782eebd7a9412aeba","14":"04fe4d85ba61dc1a131e","15":"a5ae34b049ed22a90ef8","16":"63dba2c164cecc88c8a2","17":"9dbd86ab07b1873bc117","18":"a7bfa0eb6f8b49b30691","19":"e9babae078800b70055e","20":"d32835f562004cd344e8","21":"d0e4538e923b53428eab","22":"bc4a4d31c455cc629b03","23":"d2ccbca1eb4dcd2a6be4","24":"9999e5b049badcfac1ed","25":"93e41dfcef2e577afab4","26":"a243c8d99d9dfccdadce","27":"9fe43b2161cb714c0370","28":"48c6f575219a0a690c06","29":"ed8892ace4a18f9aa1ea","30":"a21af3ce7a2999f53fb9","31":"4265d2460ecb670c9b4e","32":"0665af415d7f4f274c63","33":"cba8eade9a003e1e2b6a","34":"31c01c5e5f515a6c56fc","35":"5dd9373787a020eed800","36":"0851594c8acca4e79fa5","37":"922c24c451080d0418a4","38":"4e39f28be4b89d44c081","39":"4e7ccaa34ec0f33b9fd6","40":"814854f8992e273b6ae8","41":"7f2f54c7e969b4c0f016","42":"7b59c56d9f106d566b01","43":"cbbc0a4c2114db897834","44":"5b592f250f844d2e42c0","45":"fe6b483545019fa33f49","46":"d96c8257bc14eb4e7fe5","47":"af62cddfd8a829e12d2d","48":"da652a94c6ad6fdb94eb","49":"3311c735fe9273992beb","50":"fb80eccb6360e36de7c7","51":"e4911f9edb52da0ed02d","52":"4378e4e7cfb4e96c746f","53":"e965818a02afd76b6ae4","54":"a1af4e2f37eaceaac3af"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
